import { useMap, useMapsLibrary } from "@vis.gl/react-google-maps";
import { useEffect, useState } from "react";

export const useDrawingManager = () => {
  const [show, setShow] = useState(false);
  const [drawingManager, setDrawingManager] =
    useState<google.maps.drawing.DrawingManager | null>(null);
  const [polygon, setPolygon] = useState<{ lat: number; lng: number }[] | null>(
    null
  );
  const [overlay, setOverlay] = useState<google.maps.Polygon | null>(null);

  const map = useMap();
  const drawing = useMapsLibrary("drawing");

  useEffect(() => {
    if (!drawingManager) return;

    drawingManager.addListener(
      "polygoncomplete",
      (poly: google.maps.Polygon) => {
        const path = poly
          .getPath()
          .getArray()
          .map((itm) => ({
            lat: itm.lat(),
            lng: itm.lng(),
          }));

        console.log("polygon complete", poly);
        setOverlay(poly);
        setPolygon(path);
      }
    );
  }, [drawingManager]);

  useEffect(() => {
    if (!map || !drawing) return;

    if (show && drawingManager === null) {
      const newManager = new drawing.DrawingManager({
        drawingMode: google.maps.drawing.OverlayType.POLYGON,
        drawingControl: false,
        polygonOptions: {
          fillColor: "#199ee0",
          fillOpacity: 0.2,
          strokeWeight: 2,
          strokeColor: "#113460",
          clickable: true,
          editable: true,
          geodesic: false,
          visible: true,
          zIndex: 1,
        },
      });

      newManager.setMap(map);
      setDrawingManager(newManager);
    }

    if (show && drawingManager) {
      drawingManager.setMap(map);
    }

    if (!show && drawingManager) {
      drawingManager.setMap(null);
    }

    return () => {
      if (drawingManager) {
        drawingManager.setMap(null);
      }
    };
  }, [show, map, drawing, drawingManager]);

  return { show, setShow, polygon, overlay };
};
